<div class="summary-details">
  <div class="summary-details-item" *ngFor="let booking of cart?.bookings">
    <div class="summary-details-header">
      <h2>{{booking.event.product.name}} <span class="promocode-mark" *ngIf="booking.attachPromocode === currentPromocode"></span></h2>
      <span>
        <p class="warning-pending" *ngIf="showMessagePendingConfirm(booking)">This booking will remain pending confirmation. Please wait for confirmation by email.</p>
      </span>
      <h3 *ngIf="booking.event.product.transport">{{booking.event.product.transport.name}}</h3>
      <p class="departure" *ngIf="!isToHideDate()">Departure date: {{utils.formatDateTime(moment(booking.event.start))}}</p>
      <p class="duration" *ngIf="!isToHideDate()">Duration: {{utils.formatDuration(moment(moment().format('YYYY-MM-DD') + ' ' + booking.event.duration))}}</p>
    </div>
    <div class="summary-details-table">
      <div class="item" *ngFor="let genderPrice of booking.bookingGenderPrices">
        <span *ngIf="genderPrice.quantityToBook > 0">
          {{genderPrice.quantityToBook}} x
          {{genderPrice.audienceTypeDescription ? genderPrice.audienceTypeDescription : 'Tickets'}}
        </span>
      </div>
      <div class="item" *ngFor="let component of booking.bookingComponentsGrouped">
        <span>{{component.quantity}} x {{component.component.name}} - {{component.componentPrice.name}}</span>
      </div>
      <div class="item" *ngFor="let transfer of booking?.transport?.transfers">
        <span>{{transfer.transportDirectionDescription}} - {{utils.formatDateTime(moment(transfer.date))}} - {{transfer.stop.name}}</span>
      </div>
      <div style="margin-top: 26px;">
        <span class="summary-details-item-amount">{{utils.convertValueToCurrency(booking.billingTotal)}}</span>
      </div>
    </div>
  </div>

  <div *ngIf="!isToHidePromocode" class="summary-details-promocode">
    <div class="promocode-toggle" (click)="togglePromocodesCollapse()">
      <label style="margin-left: 0;">Promocodes</label>
    </div>
    <div class="promocode-input"
         [ngStyle]="collapseStyles"
         *ngIf="!currentPromocode">
      <div class="input-container" *ngIf="!currentPromocode">
        <app-text-input [loading]="findingPromocode"
                        [placeholder]="'Ex: PROMO10'"
                        [value]="promocode"
                        (onChange)="promocode = $event">
        </app-text-input>
        <button class="btn btn-primary" (click)="applyPromocode()">Apply</button>
      </div>
    </div>
    <div class="promocode-error" [title]="getPromocodeErrorMessage()" *ngIf="promocodeNotValid">
      <span>{{getPromocodeErrorMessage()}}</span>
    </div>
    <span class="promocode" *ngIf="currentPromocode">
       <span class="promocode-mark"></span>
      {{currentPromocode}}
      <span class="ico-close" (click)="removePromocodeFromCart()"></span>
    </span>
  </div>
  <div class="summary-details-footer">
    <span>Total cost</span>
    <span>{{utils.convertValueToCurrency(cart ? cart.billingTotal : 0)}}</span>
  </div>
</div>
<form class="booking-form" autocomplete="off" (ngSubmit)="book().then()" *ngIf="customer" #bookingForm="ngForm">
  <div class="input-container name-input">
    <label>Full Name <span>*</span></label>
    <div class="input-group">
      <input class="form-control" type="text" autocomplete="off" [(ngModel)]="customer.name" [ngModelOptions]="{standalone: true}">
    </div>
    <div *ngIf="!customer.name" class="error smaller">
      Name is required
    </div>
  </div>

  <div class="input-container">
    <label>Country <span>*</span></label>
    <div class="input-group">

      <app-dropdown 
        [options]="nationalities"
        [grouped]="true"
        [placeholder]="customer.country ? countryString(customer.country) : 'Select country'" 
        color="white"
        [enableSearch]="true" 
        (onChange)="onCountrySelect($event.value)">
      </app-dropdown>

    </div>
    <div *ngIf="!customer.country" class="error smaller">
      Country is required
    </div>
  </div>

  <div class="input-container">
    <label>Phone <span>*</span></label>
    <div class="input-group">
      <div class="d-flex">
        <input class="form-control dial-width mr-2" autocomplete="off" type="text" [(ngModel)]="customer.dial" (ngModelChange)="onDialInput()">
        <input class="form-control phone-width fs-small" type="phone" autocomplete="off" [(ngModel)]="customer.phone" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="error smaller" *ngIf="isPhoneEmpty() || isDialEmpty()">Dial and Phone is required</div>
    <div *ngIf="!isPhoneEmpty() && !isPhoneValid() && !isDialEmpty()" class="error smaller">Invalid phone number</div>
  </div>

  <div class="input-container email-input">
    <label>Email <span>*</span></label>
    <div class="input-group">
      <input class="form-control" type="email" autocomplete="off" [(ngModel)]="customer.email" [ngModelOptions]="{standalone: true}" (ngModelChange)="matchEmails(); validateCustomerEmail()">
    </div>
    <div class="error smaller" *ngIf="!emailValid && customer.email && emailsMatch">
      Please insert a valid email.
    </div>
    <div *ngIf="!customer.email" class="error smaller">
      Email is required.
    </div>
    <div class="error smaller" *ngIf="!emailsMatch">
      Emails do not match.
    </div>
  </div>

  <div class="input-container confirm-email-input">
    <label>Confirm your email <span>*</span></label>
    <div class="input-group">
      <input class="form-control" type="email"  autocomplete="off" [(ngModel)]="confirmEmail" [ngModelOptions]="{standalone: true}" (ngModelChange)="matchEmails(); validateCustomerEmail()">
    </div>
    <div class="error smaller ml-1" *ngIf="!emailValid && confirmEmail && emailsMatch">
      Please insert a valid email.
    </div>
    <div *ngIf="!confirmEmail" class="error smaller ml-1">
      Email is required.
    </div>
    <div class="error smaller ml-1" *ngIf="!emailsMatch">
      Emails do not match.
    </div>
  </div>

  <div class="input-container notes-input">
    <label>Notes</label>
    <div class="input-group">
      <textarea class="form-control"  autocomplete="off" [(ngModel)]="customer.specialAssistanceNote" [ngModelOptions]="{standalone: true}"></textarea>
    </div>
  </div>

  <div class="billing-form">
    <div class="billing-toggle" (click)="toggleBillingCollapse()">
      <div class="icon-container">
        <span class="ico-add" *ngIf="isBillingCollapsed && !requiredDueBillingPrice"></span>
        <span class="ico-minus" *ngIf="!isBillingCollapsed && !requiredDueBillingPrice"></span>
      </div>
      <label *ngIf="!isBillingCollapsed">Billing Details</label>
      <label *ngIf="isBillingCollapsed">Add Billing Details</label>
    </div>

    <div class="billing-details" *ngIf="billingDetails" [ngbCollapse]="isBillingCollapsed" [ngStyle]="billingCollapseStyles">
      <div class="input-container vat-input">
        <label>VAT Number <span *ngIf="requiredDueBillingPrice">*</span></label>
        <div class="input-group">
          <input class="form-control" type="text" autocomplete="off" [(ngModel)]="billingDetails.vat" [ngModelOptions]="{standalone: true}">
        </div>
        <div *ngIf="!billingDetails.vat && requiredDueBillingPrice" class="error smaller">
          VAT Number is required
        </div>
      </div>

      <div class="input-container country-input">
        <label>Country <span *ngIf="requiredDueBillingPrice">*</span></label>
        <div class="input-group">
          <app-dropdown 
            [options]="nationalities"
            [grouped]="true"
            [placeholder]="billingDetails.country ? countryString(billingDetails.country) : 'Select country'" 
            color="white"
            [enableSearch]="true" 
            (onChange)="onCountrySelect($event.value, 'billing')">
          </app-dropdown>
        </div>
        <div *ngIf="!billingDetails.country && requiredDueBillingPrice" class="error smaller">
          Country is required
        </div>
      </div>

      <div class="input-container name-input">
        <label>Billing Name <span *ngIf="requiredDueBillingPrice">*</span></label>
        <div class="input-group">
          <input class="form-control" type="text" autocomplete="off" [(ngModel)]="billingDetails.businessName" [ngModelOptions]="{standalone: true}">
        </div>
        <div *ngIf="!billingDetails.businessName && requiredDueBillingPrice" class="error smaller">
          Billing Name is required
        </div>
      </div>

      <div class="input-container address-input">
        <label>Address <span *ngIf="requiredDueBillingPrice">*</span></label>
        <div class="input-group">
          <input class="form-control" type="text" autocomplete="off" [(ngModel)]="billingDetails.address" [ngModelOptions]="{standalone: true}">
        </div>
        <div *ngIf="!billingDetails.address && requiredDueBillingPrice" class="error smaller">
          Address is required
        </div>
      </div>
    </div>
  </div>

  <div class="input-container terms-input">
    <label>
      <input type="checkbox" [(ngModel)]="termsAccepted" [ngModelOptions]="{standalone: true}">
      I accept <a routerLink="/terms" queryParamsHandling="merge" (click)="saveCustomer()">the terms and cancellation conditions</a>
      <span>*</span>
    </label>
  </div>

  <div class="input-container submit-btn">
    <button
      type="submit"
      class="btn btn-success"
      [disabled]="isLoading || !termsAccepted || validateCustomerDetails() || validateBillingDetails()">
      Book Now
    </button>
  </div>
</form>
